import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ReactComponent as LogoWebAzul } from '../images/Logo_AJ_azul.svg';
import { ReactComponent as IconoGithub } from '../images/github.svg';
import { ReactComponent as IconoLinkedin } from '../images/linkedin.svg';
import { ReactComponent as SVGMenu } from '../images/menu-responsive-three-lines.svg';

import {
    NavbarLateral,
    Body,
    DivLogo,
    Nav,
    NavResponsive,
    Redes,
    RedesResponsive,
    Empleo,
    ContainerResponsiv
} from '../styles/template/navbar.styles';
import Boton from '../styles/components/button.styles';

const NavLateral = () => {
    // State management for mobile navigation
    const [isMobileNavbarActive, setIsMobileNavbarActive] = useState(false);
    const [isHamburguerMenuActive, setIsHamburgerMenuActive] = useState(false);

    // Toggle menu visibility
    const showResponsiveNavbar = () => {
        setIsMobileNavbarActive(!isMobileNavbarActive);
        setIsHamburgerMenuActive(!isHamburguerMenuActive);
    };

    // Effect to update side drawer position
    useEffect(() => {
        const container = document.querySelector('.responsive-navbar-container');

        if (container) {
            if (!isMobileNavbarActive) {
                container.style.left = '-100%';
                setIsHamburgerMenuActive(false);
            } else {
                container.style.left = '0';
            }
        }
    }, [isMobileNavbarActive]);

    return (
        <>
            <NavbarLateral>
                <Body className='bodyLateral'>
                    <DivLogo className='divLogo'>
                        <Link to="/" className='logoA'>
                            <LogoWebAzul className='logo' />
                        </Link>
                        <Empleo className='employee'>Desarrollador de software</Empleo>
                    </DivLogo>

                    <DivLogo 
                        className={isHamburguerMenuActive ? "svgMenu active" : "svgMenu"} 
                        onClick={showResponsiveNavbar}
                    >
                        <SVGMenu className="SVG" />
                    </DivLogo>

                    <Nav className='navbar'>
                        <Boton to="/" className='go-up-desktop'>
                            Inicio
                        </Boton>
                        <Boton to="/about" className='go-up-desktop'>
                            Acerca de
                        </Boton>
                        <Boton to="/portfolio" className='go-up-desktop'>
                            Portafolio
                        </Boton>
                        <Boton to="/contact" className='go-up-desktop'>
                            Contacto
                        </Boton>
                    </Nav>

                    <Redes className='redes'>
                        <li>
                            <a 
                                target='_blank' 
                                rel="noopener noreferrer"
                                href="https://www.linkedin.com/in/alan-jim%C3%A9nez-a46077207/" 
                            >
                                <IconoLinkedin />
                            </a>
                        </li>
                        <li>
                            <a 
                                target='_blank' 
                                rel="noopener noreferrer"
                                href="https://github.com/AlanD24" 
                            >
                                <IconoGithub />
                            </a>
                        </li>
                    </Redes>
                </Body>
            </NavbarLateral>

            <ContainerResponsiv className='responsive-navbar-container'>
                <NavResponsive className='navResponsive'>
                    <Boton to="/" className='go-up-mobile' onClick={showResponsiveNavbar}>
                        Inicio
                    </Boton>
                    <Boton to="/about" className='go-up-mobile' onClick={showResponsiveNavbar}>
                        Acerca de
                    </Boton>
                    <Boton to="/portfolio" className='go-up-mobile' onClick={showResponsiveNavbar}>
                        Portafolio
                    </Boton>
                    <Boton to="/contact" className='go-up-mobile' onClick={showResponsiveNavbar}>
                        Contacto
                    </Boton>
                </NavResponsive>

                <RedesResponsive>
                    <li>
                        <a 
                            href="https://www.linkedin.com/in/alan-jim%C3%A9nez-a46077207/" 
                            target='_blank' 
                            rel="noopener noreferrer"
                        >
                            <IconoLinkedin />
                        </a>
                    </li>
                    <li>
                        <a 
                            href="https://github.com/AlanD24" 
                            target='_blank' 
                            rel="noopener noreferrer"
                        >
                            <IconoGithub />
                        </a>
                    </li>
                </RedesResponsive>
            </ContainerResponsiv>
        </>
    );
};

export default NavLateral;